import { RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
const ɵ0 = () => import("./main/public-lead/public-lead.module.ngfactory").then(m => m.PublicLeadModuleNgFactory), ɵ1 = () => import("./layouts/main-layout/main-layout.module.ngfactory").then(m => m.MainLayoutModuleNgFactory);
const routes = [
    {
        path: 'get-quote',
        loadChildren: ɵ0
    },
    {
        path: '',
        loadChildren: ɵ1
    },
    { path: '404', component: PageNotFoundComponent },
    { path: '**', redirectTo: '/404' }
];
export const Routing = RouterModule.forRoot(routes);
export { ɵ0, ɵ1 };
